import {
  TTranslationEvent,
} from '@/components/item-notification/item-notification.ts';

const event: TTranslationEvent = {
  job_finished: {
    label: '{assetDisplayName}',
    description: 'Zadanie {displayName} z recepty: {recipeDisplayName} jest zakończone w {finishedAtUtc} na {assetDisplayName} w {locationDisplayName}.\nJob description: {description}',
  },
  job_started: {
    label: '{assetDisplayName}',
    description: 'Zadanie {displayName} z recepty: {startedAtUtc} jest zakończone w {finishedAtUtc} na {assetDisplayName} w {locationDisplayName}.\nJob description: {description}',
  },
  timeseries_lag_detected: {
    label: '{assetDisplayName}',
    description: 'Wykryto opóźnienie szeregów czasowych w obiekcie {assetDisplayName} w lokalizacji {locationDisplayName}',
  },
  alarm_occurred: {
    label: '{assetDisplayName}',
    description: '{severityTranslation} \'{alarmDisplayName}\' wykryto na {assetDisplayName} w {locationDisplayName}',
  },
  new_qmulus_release: {
    label: 'Nowa wersja Qmulusa',
    description: 'Qmulus v{version} właśnie została wydana. Zobacz informacje o wydaniu, aby dowiedzieć się więcej',
  },
  control_level_exceeded: {
    label: 'Poziom kontroli przekroczony',
    description: 'Przekroczono poziom kontroli odczytów czujnika',
  },
  drift_detected: {
    label: 'Wykryto dryf',
    description: 'Odczyty czujników odbiegają od wartości odniesienia',
  },
  trend_detected: {
    label: 'Wykryto trend',
    description: 'Qmulus wykrył nowy trend w odczytach czujników',
  },
  maintenance_occurrence_state_changed: {
    label: 'Zmieniono stan konserwacji',
    description: 'Zmieniono status konserwacji {seriesDisplayName} na {assetDisplayName} na {maintenanceStateTranslation}',
  },
};

export default {
  markAsRead: 'Oznacz jako przeczytane',
  goToEvent: 'Przejdź do wydarzenia',
  event,
  timeseriesLagStopped: {
    label: '{assetDisplayName}: Opóźnienie szeregów czasowych ustąpiło',
    description: 'Opóźnienie szeregów czasowych w obiekcie {assetDisplayName} w lokalizacji {locationDisplayName} ustąpiło',
  },
};
